module.exports = require('./helpers/bundle-url').getBundleURL('9iXDo') + "IMG_0003.31196289.jpg" + "?" + Date.now();